'use client';

import { c as _c } from "react/compiler-runtime";
import { isFundingHostRouteEnabled, OnrampApiError, type OnrampClient, onrampManifest } from '@morfi/onramp-sdk';
import { useConnectedExchanges, useConnectedWalletCapability, useCryptoDepositCapability, useFundingNavigation, useSavedFundingMethods } from '@morfi/onramp-sdk/react';
import { useTranslations } from 'next-intl';
import { type ReactNode, useEffect } from 'react';
import { useFeatureGate } from '@/hooks/use-feature-gate';
import { logger } from '@/lib/telemetry/logger';
import { useFundingStage } from '../shared/funding-chrome';
import { FundingMethodPickerView, type FundingMethodPickerViewProps } from './funding-method-picker-view';
export { FundingOptionRow } from './funding-method-row';
export function FundingMethodPicker(t0) {
  const $ = _c(28);
  let client;
  let props;
  if ($[0] !== t0) {
    ({
      client,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = client;
    $[2] = props;
  } else {
    client = $[1];
    props = $[2];
  }
  const t = useTranslations("onramp");
  const saved = useSavedFundingMethods(client);
  const exchanges = useConnectedExchanges(client, "web");
  const cryptoDeposit = useCryptoDepositCapability(client, "web");
  const connectedWallet = useConnectedWalletCapability(client, "web");
  const navigation = useFundingNavigation(client);
  const tab = props.directPurchase ? "money" : navigation.pickerCategory;
  let t1;
  if ($[3] !== t) {
    t1 = t("deposit_title");
    $[3] = t;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  useFundingStage(t1, true, undefined, tab === "wallets" || !props.providerFeedbackOwnsStage, props.onProfile);
  const t2 = useFeatureGate("onramp_enabled") === true;
  let t3;
  if ($[5] !== t2) {
    t3 = isFundingHostRouteEnabled(onrampManifest, "manual_transfer", "web", t2, true);
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const manualEnabled = t3;
  let t4;
  let t5;
  if ($[7] !== saved.error || $[8] !== saved.isError) {
    t4 = () => {
      if (saved.isError) {
        logger.warn("onramp.saved_methods_failed", {
          code: saved.error instanceof OnrampApiError ? saved.error.code : "onramp_request_failed"
        });
      }
    };
    t5 = [saved.isError, saved.error];
    $[7] = saved.error;
    $[8] = saved.isError;
    $[9] = t4;
    $[10] = t5;
  } else {
    t4 = $[9];
    t5 = $[10];
  }
  useEffect(t4, t5);
  let t6;
  if ($[11] !== saved.data) {
    t6 = saved.data ?? [];
    $[11] = saved.data;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const t7 = connectedWallet.data === true;
  const t8 = cryptoDeposit.data === true;
  let t9;
  if ($[13] !== exchanges.data) {
    t9 = exchanges.data?.includes("coinbase");
    $[13] = exchanges.data;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  const t10 = t9 === true;
  let t11;
  if ($[15] !== connectedWallet.isPending || $[16] !== manualEnabled || $[17] !== navigation.openConnectedWallet || $[18] !== navigation.openCryptoDeposit || $[19] !== navigation.openManualTransfer || $[20] !== navigation.setPickerCategory || $[21] !== props || $[22] !== t10 || $[23] !== t6 || $[24] !== t7 || $[25] !== t8 || $[26] !== tab) {
    t11 = <FundingMethodPickerView {...props} savedMethods={t6} tab={tab} setPickerCategory={navigation.setPickerCategory} connectedWalletEnabled={t7} connectedWalletLoading={connectedWallet.isPending} cryptoDepositEnabled={t8} manualEnabled={manualEnabled} exchangeEnabled={t10} onConnectedWallet={navigation.openConnectedWallet} onCryptoDeposit={navigation.openCryptoDeposit} onManualTransfer={navigation.openManualTransfer} />;
    $[15] = connectedWallet.isPending;
    $[16] = manualEnabled;
    $[17] = navigation.openConnectedWallet;
    $[18] = navigation.openCryptoDeposit;
    $[19] = navigation.openManualTransfer;
    $[20] = navigation.setPickerCategory;
    $[21] = props;
    $[22] = t10;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
    $[26] = tab;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  return t11;
}